<template>
  <div class="child-nomination-list">
    <p>{{name}}</p>
    <ul class="fa-ul">
      <li v-for="award in awards" v-bind:key="award.child_nomination_award_slug">
        <span class="fa-li"><i class="fas fa-video fa-fw fa-sm text-primary"></i></span>
        <router-link :to="'/ve-awards/ve-award/' + award.child_nomination_award_slug">
          {{award['child-nomination-award-title']}} <i class="fas fa-angle-right"></i>
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: [
    'name',
    'awards'
  ]
}
</script>



// WEBPACK FOOTER //
// src/components/ChildNominationEventsList.vue